// extracted by mini-css-extract-plugin
export var messageSideLeft = "_j7-1";
export var messageSideRight = "_j7-2";
export var orderLookupBubbleContainer = "_j7-0";
export var submitButton = "_j7-3";